import React from 'react';
import './Home.css';
import Auth from './Auth/Auth'
const Home = () => {
    return (
<div className='Home'>
    <Auth />
        </div>
    )
}

export default Home